import React from 'react'
import { Card, CardBody, CardHeader } from 'components/Card/Card'
import { BigText, MediumText, NormalText } from 'styling/TypographyV2'
import { colors, ColorVariant, Flex, SmallText } from 'styling/GlobalStyles'
import { ProcurementPurchaseRequestListResponse } from 'types/procurement/purchaseRequest.model'
import { EmptyList } from 'components/Table/EmptyList'
import { getProcurementPurchaseRequestAuditLogs } from 'api/procurement.api'
import { useQuery } from '@tanstack/react-query'
import { ProcurementPurchaseRequestAuditLogResponse } from 'types/procurement/auditLog.model'
import styled from 'styled-components'
import { convertToDate } from 'utils/helpers'

export const AuditLogs = ({
  purchaseRequest,
}: {
  purchaseRequest: ProcurementPurchaseRequestListResponse
}) => {
  const { data, isLoading } = useQuery({
    queryKey: ['procurement-purchase-request-audit-logs', purchaseRequest.id],
    queryFn: () => getProcurementPurchaseRequestAuditLogs(purchaseRequest.id),
  })
  return (
    <Card padding='0.5rem 1rem' height='fit-content'>
      <CardHeader>
        <BigText semibold colorVariant={ColorVariant.BASE}>
          Audit Log
        </BigText>
      </CardHeader>
      <CardBody>
        <Flex column gap='0.75rem' mt='12' mb='12'>
          {data?.length > 0 ? (
            data.map((auditLog) => <AuditLogItem key={auditLog.id} auditLog={auditLog} />)
          ) : (
            <EmptyList title='No audit logs found' description='No audit logs found' />
          )}
        </Flex>
      </CardBody>
    </Card>
  )
}

const AuditLogItem = ({ auditLog }: { auditLog: ProcurementPurchaseRequestAuditLogResponse }) => {
  return (
    <Flex gap='0.25rem' position='relative' ml='8'>
      <Dot />
      <Flex column ml='16'>
        <NormalText>{auditLog.title}</NormalText>
        <MediumText colorVariant={ColorVariant.SECONDARY} mt='0.25rem'>
          by {auditLog.user.firstName} {auditLog.user.lastName} •{' '}
          {convertToDate(auditLog.createdAt)}
        </MediumText>
        {auditLog.message && (
          <MediumText colorVariant={ColorVariant.SECONDARY} mt='0.25rem'>
            {auditLog.message}
          </MediumText>
        )}
      </Flex>
    </Flex>
  )
}

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colorOrange};
  position: absolute;
  top: 7px;
`
